import { ShieldAlert } from "lucide-react";

interface TabWarningBannerProps {
  title?: string;
  message?: string;
}

const TabWarningBanner = ({
  title = "Advertencia",
  message = "Esta sección requiere permisos especiales para acceder.",
}: TabWarningBannerProps) => (
  <div className="flex items-start gap-3 rounded-lg border border-yellow-300 bg-yellow-50 p-4">
    <ShieldAlert className="h-5 w-5 text-yellow-600 mt-0.5" />

    <div className="flex-1">
      <h3 className="text-sm font-semibold text-yellow-800">{title}</h3>
      <p className="mt-1 text-sm text-yellow-700">{message}</p>
    </div>
  </div>
);

export default TabWarningBanner;
